import { Route, Routes, useNavigate } from 'react-router-dom';
import 'animate.css';
import StoreFront from '../pages/StoreFront';
import Login from '../pages/Login';
import SignUp from '../pages/SignUp';
import Checkout from '../pages/Checkout';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { useEffect } from 'react';
import { fetchUserInfo, logout } from '../store/authSlice';
import { fetchPurchaseCart } from '../store/purchaseSlice';
import { clearError } from '../store/purchaseSlice';
import { ToastContainer } from 'react-toastify';
import AccountDetails from '../pages/AccountDetails';
import History from '../pages/History';
import { updatePurchaseCartAsync } from '../store/purchaseSlice';
import { CartLineItems } from '../interfaces';

import { removeMultipleIndexes } from '../utils';
import CreatePassword from '../pages/CreatePassword';
import PasswordSetRequest from '../pages/PasswordSetRequest';
import PurchaseSummary from '../pages/PurchaseSummary';
import AddressPicker from '../components/AddressPicker';

function AllRoute() {
  const auth_token = useSelector((state: RootState) => state.auth.token);
  const { routesPrefix, pathPrefix } = useSelector(
    (state: RootState) => state.setup
  );
  // const { productsDictionary } = useSelector(
  //   (state: RootState) => state.products
  // );
  const { error: purchaseError, purchase } = useSelector(
    (state: RootState) => state.purchase
  );
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(clearError());
    dispatch(fetchUserInfo());
  }, [dispatch]);

  useEffect(() => {
    if (auth_token) {
      dispatch(fetchPurchaseCart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth_token]);

  useEffect(() => {
    if (purchase) {
      if (purchase.purchases) {
        const filteredCart: CartLineItems[] = purchase.purchases.map(
          ({ quantity, specialRequest, productVariantId }) => ({
            quantity,
            specialRequest,
            productVariantId,
          })
        );
        const temp_purchases = [...filteredCart];
        const to_remove_from_cart: number[] = [];

        if (to_remove_from_cart.length > 0) {
          const CartLineItems = removeMultipleIndexes(
            temp_purchases,
            to_remove_from_cart
          );
          const purchaseCode = '';
          dispatch(updatePurchaseCartAsync({ CartLineItems, purchaseCode }));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (purchaseError === 'Unauthorized' && auth_token !== null) {
      dispatch(logout());
      navigate(`${routesPrefix}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseError]);
  return (
    <div
      className="min-w-screen h-screen 
      !overflow-auto bg-white relative "
    >
      <div className="w-full m-auto h-full bg-white relative">
        <ToastContainer autoClose={5000} />
        <div className="w-screen m-auto h-full relative">
          <Routes>
            <Route path="/" element={<StoreFront />} />
            <Route path="/:storeId" element={<StoreFront />} />
            <Route path="/:companyId/:storeId" element={<StoreFront />} />
            <Route path={`${pathPrefix}`} element={<StoreFront />} />
            <Route
              path={`${pathPrefix}address-picker`}
              element={<AddressPicker />}
            />
            <Route
              path={`${pathPrefix}auth`}
              element={
                auth_token !== null && auth_token !== '' ? (
                  <StoreFront />
                ) : (
                  <Login />
                )
              }
            />
            <Route
              path={`${pathPrefix}signup`}
              element={
                auth_token !== null && auth_token !== '' ? (
                  <StoreFront />
                ) : (
                  <SignUp />
                )
              }
            />
            <Route
              path={`${pathPrefix}setpassword`}
              element={
                auth_token !== null && auth_token !== '' ? (
                  <StoreFront />
                ) : (
                  <CreatePassword />
                )
              }
            />

            <Route
              path={`${pathPrefix}resetpassword`}
              element={
                auth_token !== null && auth_token !== '' ? (
                  <StoreFront />
                ) : (
                  <PasswordSetRequest />
                )
              }
            />

            <Route
              path={`${pathPrefix}receipt/:purchaseCode`}
              element={<PurchaseSummary />}
            />
            <Route
              path={`${pathPrefix}history`}
              element={
                auth_token !== null && auth_token !== '' ? (
                  <History />
                ) : (
                  <SignUp />
                )
              }
            />
            <Route path={`${pathPrefix}cart`} element={<Checkout />} />

            <Route
              path={`${pathPrefix}account`}
              element={
                auth_token !== null && auth_token !== '' ? (
                  <AccountDetails />
                ) : (
                  <Login />
                )
              }
            />
          </Routes>
        </div>
        {/* <div className='w-full h-[100px] '></div> */}
      </div>
    </div>
  );
}

export default AllRoute;
